module.exports = __webpack_public_path__ + "static/media/6.60bbdcd3.svg";